import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {TransferAccountStep, MessageFormat, IconList, ButtonColor, transferOption} from './Constant/Constant';
import {setCurrentStep, setShowPopUp, setEpiData, saveToHistory, resetState} from './TransferOrganizationAccountSlice';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import {getContactCompanyList} from './../PortalsBlock/portalSlice';
import TransferLine from './Steps/TransferLineStep/TransferLine';
import PlanSelection from './Steps/PricePlanStep/PlanSelection';
import TransferOrganizationPopup from './TransferOrganizationAccountPopup';
import Popup from '../../Shared/Popup/PopUp';
import EsimConfirmation from './Steps/EsimConfirmation';
import DeliveryPersonalInfo from './Steps/SimOrderStep/DeliveryPersonalInfo';
import DeliveryTimeSlots from './Steps/SimOrderStep/DeliveryTimeSlots';
import GeneralMessage from './Popups/GeneralMessage';
import SelectCompany from '../../Shared/SelectBusinessCompany/SelectCompany';
import CreateSimOrderSuccessPage from './Steps/SimOrderStep/CreateSimOrderSuccessPage';
import {dwhFirstOnloadReport} from './Reports/dwhReports';
import EsimInstruction from './Steps/EsimInstruction';
import EsimSuccessPage from './Steps/EsimSuccessPage';
const TransferOrganizationAccountMain = (props) => {
  useEffect(() => {
    props.setEpiData(props.iContent);
    let selectedHetPay = props.portalsBlock.selectedHetPay;
    const userDetails = props.authentication?.loginData?.userDetails;
    dwhFirstOnloadReport({selectedHetPay, userDetails});
    return () => {
      props.resetState();
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [props.data.currentStep]);

  useEffect(() => {
    async function loadCompanies() {
      props.showAppLoader();
      await props.getContactCompanyList();
      await props.hideAppLoader();
      props.setCurrentStep(TransferAccountStep.SelectCompany);
    }
    if (
      props.portalsBlock.hetPaysNumbers.length == 0 &&
      !props.portalsBlock.requestCompleted &&
      props.authentication?.loginData?.userDetails.IsContactPerson
    ) {
      loadCompanies();
    } else if (props.portalsBlock.hetPaysNumbers.length > 0 && !props.portalsBlock.selectedHetPay) {
      props.setCurrentStep(TransferAccountStep.SelectCompany);
    }
  }, [props.authentication]);

  const generalMessageActions = {
    goToTransferLineStep: () => props.setCurrentStep(TransferAccountStep.TransferLine),
    resetState: () => props.resetState(),
  };

  let currentStep = () => {
    props.saveToHistory(props.data.currentStep);
    switch (props.data.currentStep) {
      case TransferAccountStep.SelectCompany:
        return <SelectCompany setNextStep={() => props.setCurrentStep(TransferAccountStep.TransferLine)} title='הפעלת קו חדש' />;
      case TransferAccountStep.TransferLine:
        return <TransferLine />;
      case TransferAccountStep.PlanSelection:
        return <PlanSelection />;
      case TransferAccountStep.EsimConfirmation:
        return <EsimConfirmation />;
      case TransferAccountStep.DeliveryPersonalInfo:
        return <DeliveryPersonalInfo />;
      case TransferAccountStep.DeliveryTimeSlot:
        return <DeliveryTimeSlots />;
      case TransferAccountStep.SimOrderSuccessPage:
        return <CreateSimOrderSuccessPage />;
      case TransferAccountStep.EsimSuccessPage:
        return <EsimSuccessPage />;
      case TransferAccountStep.EsimInstruction:
        return <EsimInstruction />;
      case TransferAccountStep.GeneralMessage:
        return (
          <GeneralMessage
            messageData={props.data.generalMessage}
            buttonClick={generalMessageActions[props.data.generalMessage.buttonClick]}
            secondButtonClick={generalMessageActions[props.data.generalMessage.secondButtonClick]}
            isNewLineAction={props.data.selectedTransferOption === transferOption.newLine}
          />
        );
      default:
        break;
    }
  };

  return (
    <div className='transferOrganizationAccount'>
      {currentStep()}

      <Popup className={`${props.data.currentPopUp} mainPopup`} showPopUp={props.data.showPopup} onClose={() => props.setShowPopUp(false)}>
        <TransferOrganizationPopup />
      </Popup>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.TransferOrganizationAccount,
  portalsBlock: state.portalsBlock,
  authentication: state.authentication,
});

const mapDispatchToProps = {
  setShowPopUp,
  setEpiData,
  setCurrentStep,
  saveToHistory,
  getContactCompanyList,
  showAppLoader,
  hideAppLoader,
  resetState,
};

export default connect(mapStateToProps, mapDispatchToProps)(TransferOrganizationAccountMain);
